export function normalizeAppPathname(pathname: string): string {
  let normalized = String(pathname || "").trim() || "/";
  if (normalized === "/ui") return "/";
  if (normalized.startsWith("/ui/")) normalized = normalized.slice(3) || "/";
  return normalized === "/" ? normalized : normalized.replace(/\/+$/, "") || "/";
}

export function isAdminPathname(pathname: string): boolean {
  const normalized = normalizeAppPathname(pathname);
  return normalized === "/administrator" ||
    normalized.startsWith("/administrator/") ||
    normalized === "/admin" ||
    normalized.startsWith("/admin/");
}

export function isAuthTransitionPathname(pathname: string): boolean {
  const normalized = normalizeAppPathname(pathname);
  return normalized === "/login" || normalized === "/auth/callback";
}
